
import {
  urlGetter,
} from '@app/Filters/url'

const ATTRIBUTES_LIMIT = 3
const ATTRIBUTE_VALUES_LIMIT = 1

const EXCLUDED_VALUES = ['price_min', 'price_max', 'order']

export default {
  computed: {
    url() {
      return (slug, id) => this.urlGenerator(slug, id)
    },
  },
  methods: {
    urlGenerator(slug, id) {
      const value = JSON.parse(JSON.stringify(this.all))
      const keys = Object.keys(value).filter(e => !EXCLUDED_VALUES.find(l => l == e))
      if (!this.isAvailable(id, slug)) return null
      if (keys.length >= ATTRIBUTES_LIMIT) return null
      if (keys.some(v => value[v].length > ATTRIBUTE_VALUES_LIMIT)) return null
      if (value[this.filter.attribute.label]) return null
      value[this.filter.attribute.label] = [slug]
      const order = {
        path: [
          'prefix',
          'filters',
          'page',
        ],
      }
      const fullUrl = urlGetter([this.baseUrl], order, { filters: value })

      return fullUrl
    },
  },
}